import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";

let categoryIndex = () => import(/* webpackChunkName: "blog-categories" */ '@/views/blog/categories/Index');
let categoryCreate = () => import(/* webpackChunkName: "blog-categories" */ '@/views/blog/categories/Create');
let categoryEdit = () => import(/* webpackChunkName: "blog-categories" */ '@/views/blog/categories/Edit');
let tagIndex = () => import(/* webpackChunkName: "tags" */ '@/views/blog/tags/Index');
let tagCreate = () => import(/* webpackChunkName: "tags" */ '@/views/blog/tags/Create');
let tagEdit = () => import(/* webpackChunkName: "tags" */ '@/views/blog/tags/Edit');
let postIndex = () => import(/* webpackChunkName: "posts" */ '@/views/blog/posts/Index');
let postCreate = () => import(/* webpackChunkName: "posts" */ '@/views/blog/posts/Create');
let postEdit = () => import(/* webpackChunkName: "posts" */ '@/views/blog/posts/Edit');
 let commentIndex = () => import(/* webpackChunkName: "comments" */ '@/views/blog/comments/Index');
 let commentEdit = () => import(/* webpackChunkName: "comments" */ '@/views/blog/comments/Edit');

export default [
    ...prefix("/post/categories", [
        {
            path: "",
            name: "blog.categories.index",
            component: categoryIndex,
            meta: {
                middleware: web,
                permissions: ['post-categories:viewAny'],
                title: "دسته بندی ها"
            }
        },
        {
            path: "create",
            name: "blog.categories.create",
            component: categoryCreate,
            meta: {
                middleware: web,
                permissions: ['post-categories:create'],
                title: "ایجاد دسته بندی"
            }
        },
        {
            path: ":category",
            name: "blog.categories.edit",
            component: categoryEdit,
            meta: {
                middleware: web,
                permissions: ['post-categories:update'],
                title: "ویرایش دسته بندی"
            }
        }
    ]),
    ...prefix("/post/tags",[
        {
            path: "",
            name: "blog.tags.index",
            component: tagIndex,
            meta: {
                middleware: web,
                permissions: ['tags:viewAny'],
                title: "برچسب ها"
            }
        },
        {
            path: "create",
            name: "blog.tags.create",
            component: tagCreate,
            meta: {
                middleware: web,
                permissions: ['tags:create'],
                title: "ایجاد برچسب"
            }
        },
        {
            path: ":tag",
            name: "blog.tags.edit",
            component: tagEdit,
            meta: {
                middleware: web,
                permissions: ['tags:update'],
                title: "ویرایش برچسب"
            }
        }
    ]),
    ...prefix("/post/posts",[
        {
            path: "",
            name: "blog.posts.index",
            component: postIndex,
            meta: {
                middleware: web,
                permissions: ['posts:viewAny', 'posts:viewSelfRecords'],
                title: "مطالب"
            }
        },
        {
            path: "create",
            name: "blog.posts.create",
            component: postCreate,
            meta: {
                middleware: web,
                permissions: ['posts:create'],
                title: "ایجاد مطلب"
            }
        },
        {
            path: ":post",
            name: "blog.posts.edit",
            component: postEdit,
            meta: {
                middleware: web,
                permissions: ['posts:viewAny', 'posts:viewSelfRecords'],
                title: "ویرایش مطلب"
            }
        }
    ]),
    ...prefix("/post/comments",[
        {
            path: "",
            name: "blog.comments.index",
            query: { scope: 'post' },
            component: commentIndex,
            meta: {
                middleware: web,
                permissions: ['post-comments:viewAny'],
                title: "دیدگاه ها"
            }
        },
        {
            path: ":comment",
            name: "blog.comments.edit",
            query: { scope: 'post' },
            component: commentEdit,
            meta: {
                middleware: web,
                permissions: ['post-comments:view'],
                title: "مشاهده دیدگاه"
            }
        }
    ]),

]